import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { couponsActions } from '.';
import { ApiError } from '../../models/common/api-error';
import { of } from 'rxjs';
import { CouponsService } from '../../services/coupons.service';
import { storeCouponsKey } from '../reducers';
import { CouponsState } from './coupons.state';
import { cloneDeep } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class CouponsEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private couponsService: CouponsService,
  ) {}

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        couponsActions.findAll,
        couponsActions.setFilter,
        couponsActions.setOrder,
      ),
      withLatestFrom(this.store$),
      mergeMap(([action, store]) => {
        const filters = cloneDeep(
          (store[storeCouponsKey] as CouponsState).filters,
        );
        // @ts-ignore
        filters.order_by = filters.order?.map((orderBy) => [
          orderBy.field,
          orderBy.order,
        ]);
        return this.couponsService.findAll(filters).pipe(
          map((response) =>
            couponsActions.findAllSuccess({
              coupons: response.data,
              total: response.total,
            }),
          ),
          catchError((error: ApiError) =>
            of(couponsActions.findError({ error: error.message })),
          ),
        );
      }),
    ),
  );
}
